import styled from "styled-components";
import { theme } from "./appTheme";

export const PageContainer = styled.main({
  maxWidth: 390,
  margin: "0 auto",
  background: theme.palette.white,
  minHeight: "100vh",
});

export const PageContent = styled.div({
  padding: "24px 20px",
});

export const InitialPageContainer = styled(PageContainer)({
  padding: "0 0 28px",
});
